"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOOP_LOGGER = void 0;
exports.NOOP_LOGGER = Object.freeze({
    debug: function () { return this; },
    info: function () { return this; },
    warn: function () { return this; },
    error: function () { return this; }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBaUJhLFFBQUEsV0FBVyxHQUFXLE1BQU0sQ0FBQyxNQUFNLENBQUM7SUFDL0MsS0FBSyxFQUFFLGNBQWMsT0FBTyxJQUFJLENBQUEsQ0FBQyxDQUFDO0lBQ2xDLElBQUksRUFBRSxjQUFjLE9BQU8sSUFBSSxDQUFBLENBQUMsQ0FBQztJQUNqQyxJQUFJLEVBQUUsY0FBYyxPQUFPLElBQUksQ0FBQSxDQUFDLENBQUM7SUFDakMsS0FBSyxFQUFFLGNBQWMsT0FBTyxJQUFJLENBQUEsQ0FBQyxDQUFDO0NBQ25DLENBQUMsQ0FBQSJ9